@if (data) {
  {{ Number(data.value) | currency: (params ? params['format'] : CURRENCY_FORMAT) }}
}
